import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ExpensesView } from '../components/ExpensesView';

export default function OpsExpenses() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const autoNew = searchParams.get('new') === 'expense';

  useEffect(() => {
    if (searchParams.get('tab') || searchParams.get('new')) {
      // consume query params once
      setTimeout(() => setSearchParams({}, { replace: true }), 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="ops-expenses">
      <div className="mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-white">Expenses</h2>
        <p className="text-gray-400 mt-1">
          Track spending across every BuildBroz project. Receipts are uploaded inside each Project's Financials.
        </p>
      </div>

      <ExpensesView autoOpenCreate={autoNew} onChanged={() => setRefreshKey((k) => k + 1)} key={refreshKey} />
    </div>
  );
}
